import React, { useMemo } from 'react';
import { t } from 'i18next';
import { SupportedTokens } from '@sovryn/contracts';
import { Button } from '@sovryn/ui';
import { useAssetBalance } from '../../../../../hooks/useAssetBalance';
import { translations } from '../../../../../locales/i18n';
export const ConnectedUserBanner = ({ openLOC, }) => {
    const { balance, loading } = useAssetBalance(SupportedTokens.rbtc);
    const hasRbtcBalance = useMemo(() => Number(balance) !== 0, [balance]);
    if (!hasRbtcBalance) {
        return null;
    }
    if (loading) {
        return React.createElement("div", { className: "mb-9 h-8" });
    }
    return (React.createElement("div", { className: "flex justify-center md:justify-end mb-9" },
        React.createElement(Button, { className: "flex-1 md:flex-initial max-w-[20.5rem] md:max-w-none ", onClick: openLOC, text: t(translations.zeroPage.dashboardWelcomeBanner.OpenCredit), dataAttribute: "zero-loc-open" })));
};
